import { LoadingOutlined } from '@ant-design/icons';

export const IndicatorCustomized = () => {
    return (
        <>
            <div className='w-full h-full flex items-center justify-center' style={{ height: '100vh' }}>
                <LoadingOutlined style={{ fontSize: 50, color:'#FF6600' }} spin />
            </div>
        </>
    )
}

export const IconIndicator = () => {
    return (
        <div className="spinning-logo-container relative">
            <LoadingOutlined style={{ fontSize: 100, color:'#FF6600', lineHeight:1 }} spin className='absolute' />
            <img src={require('../../assets/icons/nilia.webp')} className='logo' alt="Nyikela Mali" />
        </div>
    );
}